import Container from "@/components/ContentContainer/Container";
import FormItemContainer from "@/components/FormHeader/FormItemContainer";
import { useCompanySettings, usePatchCompanySettings } from "@/hooks/useCompanySettings";
import { ImpactMethod } from "@/hooks/useImpactMethod";
import { message, Radio } from "antd";
import { setLocalStorageMetricKey } from "@/pages/dashboard/hooks/useImpactMetric";

export const methodOptions = [
  {
    value: "ReCiPe 2016 v1.03, midpoint (H)",
    label: "ReCiPe 2016 v1.03, midpoint (H)",
  },
  { value: "EF v3.1", label: "EF v3.1" },
];

export default function ManageMethod() {
  const { data: companySettings, isLoading } = useCompanySettings();
  const patchCompanySettings = usePatchCompanySettings();

  const onMethodChange = async (value: ImpactMethod) => {
    await patchCompanySettings.mutateAsync({
      impact_method: value,
    });
    setLocalStorageMetricKey(null);
    message.success("Method successfully changed.");
  };

  return (
    <Container title="Method">
      <div style={{ maxWidth: 400 }}>
        <FormItemContainer
          isLoading={isLoading}
          title="Change your impact method here:"
        >
          <Radio.Group
            style={{
              display: "flex",
              flexDirection: "column",
            }}
            onChange={(value) => onMethodChange(value.target.value)}
            value={companySettings?.impact_method}
            options={methodOptions}
          />
        </FormItemContainer>
      </div>
    </Container>
  );
}
